var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"badge badge-secondary"},[_vm._t("default"),_c('i',{staticClass:"fas fa-times fa-fw action",on:{"click":_vm.dismissClicked}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }